import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import WhatIsSection from "./components/WhatIsSection";
import FeatureCards from "./components/FeatureCards";
import ComparisonTable from "./components/ComparisonTable";
import ProductCategoryGrid from "./components/ProductCategoryGrid";
import ArticleGrid from "./components/ArticleGrid";
import FaqSection from "./components/FaqSection";
import FinalCta from "./components/FinalCta";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <WhatIsSection />
        <FeatureCards />
        <ComparisonTable />
        <ProductCategoryGrid />
        <ArticleGrid />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What is BaseTao Spreadsheet and how does it work?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "BaseTao Spreadsheet is a specialized organizational tool designed for international shoppers who use the BaseTao platform. It functions as a comprehensive tracking system where you can log product URLs, prices, seller information, shipping details, and order statuses in one centralized document. Users can either start with community-shared templates or build their own customized version."
                }
              },
              {
                "@type": "Question",
                "name": "Is BaseTao a legitimate shopping platform?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "BaseTao has been operating as a shopping agent for several years, serving international customers who want to purchase products from Chinese marketplaces such as Taobao, Weidian, and 1688. The platform maintains a physical warehouse and offers buyer protection policies including QC photo services and return support."
                }
              },
              {
                "@type": "Question",
                "name": "How much does BaseTao shipping cost?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "BaseTao shipping costs depend on destination country, parcel weight and dimensions, chosen shipping carrier, and additional services. Shipping methods range from economy sea freight to express air freight through DHL or FedEx. The platform provides a shipping calculator for cost estimates before committing."
                }
              },
              {
                "@type": "Question",
                "name": "What are the best BaseTao coupon codes and discounts available?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "BaseTao periodically offers promotional discounts including new user welcome coupons, seasonal sale events, and shipping fee reductions. Discount codes are distributed through official channels and during major shopping festivals. Combining platform coupons with seller discounts and parcel consolidation maximizes savings."
                }
              },
              {
                "@type": "Question",
                "name": "How do I use BaseTao warehouse and QC photo services?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "When sellers ship items to the BaseTao warehouse, each package is logged into your account with arrival date, weight, and storage location. You can request QC photos showing the actual item against a plain background with measurements visible. After reviewing photos, you can approve items for shipping, request returns, or flag issues."
                }
              },
              {
                "@type": "Question",
                "name": "Can I share my BaseTao Spreadsheet template with other users?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Absolutely. The BaseTao community actively shares spreadsheet templates, formulas, and organizational layouts through forums, social media groups, and dedicated resource pages. Many experienced users publish their templates with detailed explanations, making it easy for newcomers to adopt proven workflows."
                }
              }
            ]
          }),
        }}
      />
    </>
  );
}